import axios from 'axios';
import { showToast } from './components/toast/ToastNotifier';
import { startLoading, stopLoading } from './components/loading/LoadingManager';


const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});


// Mappa per tenere traccia delle richieste pendenti (chiave: URL+metodo)
const pendingRequests = new Map();

const getRequestKey = (config) => `${config.method}-${config.url}`;

api.interceptors.request.use(
  (config) => {
    const requestKey = getRequestKey(config);

    // Se esiste già una richiesta identica in corso, saltiamo il loading
    if (pendingRequests.has(requestKey)) {
      config.skipLoading = true;
    } else {
      pendingRequests.set(requestKey, true);
      if (!config.skipLoading) {
        startLoading();
      }
    }
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    stopLoading();
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    const requestKey = getRequestKey(response.config);
    // Rimuoviamo la richiesta dalla mappa
    pendingRequests.delete(requestKey);
    if (!response.config.skipLoading) {
      stopLoading();
    }
    const message = response.config?.customToastMessage;
    if (!response.config.skipToast && ['post', 'put', 'delete'].includes(response.config.method)) {
      showToast.success(message);
    }
    return response;
  },
  (error) => {
    if (error.config) {
      const requestKey = getRequestKey(error.config);
      pendingRequests.delete(requestKey);
      if (!error.config.skipLoading) {
        stopLoading();
      }
    }
    const message = error.config?.customToastMessage;
    if (!error.config?.skipToast) {
      if (error.response && error.response.status === 404) {
        showToast.info(message === "Qualcosa è andato storto" ? "Risorsa non trovata" : message);
      } else if (error.response && error.response.status === 500) {
        showToast.error("Errore interno del server");
        if (!error.config?.hasRedirected) {
          error.config.hasRedirected = true;
          window.location.href = "/error";
        }
      } else {
        showToast.error(message);
      }
    }
    return Promise.reject(error);
  }
);
// );




// Funzione per ottenere l'URL dell'immagine
export const getImageUrl = (imagePath) => {
  if (!imagePath) return 'https://via.placeholder.com/150';
  return `/api/${imagePath}`;
};
// Funzione per ottenere l'URL corretto per le immagini, sostituendo il percorso assoluto
export const getHotelImageUrl = (imagePath) => {
  if (!imagePath) return 'https://via.placeholder.com/150';

  // Sostituisci il prefisso assoluto con la route corretta
  const relativePath = imagePath.replace('/usr/src/app/var/', 'uploads/');
  
  return `/api/${relativePath}`;
};

// Funzione per ottenere l'URL dell'immagine avatar
export const getAvatarUrl = (imagePath) => {
  if (!imagePath) return 'https://via.placeholder.com/150';
  
  return `/api${imagePath}`;
};
export default api;













// import axios from 'axios';
// import { showToast } from './components/toast/ToastNotifier';
// import { startLoading, stopLoading } from './components/loading/LoadingManager';

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_BASE_URL,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // Mappa per tenere traccia delle richieste pendenti (chiave: URL+metodo)
// const pendingRequests = new Map();

// const getRequestKey = (config) => `${config.method}-${config.url}`;

// api.interceptors.request.use(
//   (config) => {
//     const requestKey = getRequestKey(config);

//     // Se esiste già una richiesta identica in corso, saltiamo il loading
//     if (pendingRequests.has(requestKey)) {
//       config.skipLoading = true;
//     } else {
//       pendingRequests.set(requestKey, true);
//       if (!config.skipLoading) {
//         startLoading();
//       }
//     }
//     const token = localStorage.getItem('authToken');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     stopLoading();
//     return Promise.reject(error);
//   }
// );

// api.interceptors.response.use(
//   (response) => {
//     const requestKey = getRequestKey(response.config);
//     // Rimuoviamo la richiesta dalla mappa
//     pendingRequests.delete(requestKey);
//     if (!response.config.skipLoading) {
//       stopLoading();
//     }
//     const message = response.config?.customToastMessage;
//     if (!response.config.skipToast && ['post', 'put', 'delete'].includes(response.config.method)) {
//       showToast.success(message);
//     }
//     return response;
//   },
//   (error) => {
//     if (error.config) {
//       const requestKey = getRequestKey(error.config);
//       pendingRequests.delete(requestKey);
//       if (!error.config.skipLoading) {
//         stopLoading();
//       }
//     }
//     const message = error.config?.customToastMessage;
//     if (!error.config?.skipToast) {
//       if (error.response && error.response.status === 404) {
//         showToast.info(message === "Qualcosa è andato storto" ? "Risorsa non trovata" : message);
//       } else if (error.response && error.response.status === 500) {
//         showToast.error("Errore interno del server");
//         if (!error.config?.hasRedirected) {
//           error.config.hasRedirected = true;
//           window.location.href = "/error";
//         }
//       } else {
//         showToast.error(message);
//       }
//     }
//     return Promise.reject(error);
//   }
// );



// // Funzione per ottenere l'URL dell'immagine
// export const getImageUrl = (imagePath) => {
//   if (!imagePath) return 'https://via.placeholder.com/150';
//   return `http://127.0.0.1:3000/api/${imagePath}`;
// };

// // Funzione per ottenere l'URL corretto per le immagini, sostituendo il percorso assoluto
// export const getHotelImageUrl = (imagePath) => {
//   if (!imagePath) return 'https://via.placeholder.com/150';

//   // Sostituisci il prefisso assoluto con la route corretta
//   const relativePath = imagePath.replace('/usr/src/app/var/', '/api/uploads/');
  
//   return `http://127.0.0.1:3000${relativePath}`;
// };

// // Funzione per ottenere l'URL dell'immagine avatar
// export const getAvatarUrl = (imagePath) => {
//   if (!imagePath) return 'https://via.placeholder.com/150';
  
//   // Gli avatar sono serviti come file statici, quindi non c'è bisogno di passare tramite /api
//   return `http://127.0.0.1:3000/api${imagePath}`;
// };

// export default api;






